module.exports = __webpack_public_path__ + "static/media/baby-carriage.a4653194.svg";